<template>
  <i
    class="material-icons trigger-button smooth-shadow"
    @click="$emit('click', $event)"
    size="25"
    >{{ icon }}</i
  >
</template>

<script>
export default {
  props: {
    icon: String,
  },
};
</script>

<style lang="scss" scoped>
.trigger-button {
  padding: 10px;
  background: var(--color-secondary);
  border-radius: 50%;
  transition: 0.1s all ease-in-out;

  &:hover {
    color: var(--color-primary);
    cursor: pointer;
  }

  &:active {
    transform: scale(0.9);
  }
}
</style>
